import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GeocodingService {
  // Free OpenStreetMap Nominatim endpoint
  private apiUrl = 'https://nominatim.openstreetmap.org/reverse';

  constructor(private http: HttpClient) {
  }

  async getAddress(lat: number, lng: number): Promise<string> {
    const url = `${this.apiUrl}?format=jsonv2&lat=${lat}&lon=${lng}`;

    // OpenStreetMap strictly requires a custom User-Agent header to identify your app
    const headers = new HttpHeaders({
      'User-Agent': 'MyIonicAngularApp/1.0'
    });

    try {
      const response: any = await firstValueFrom(this.http.get(url, {headers}));

      // Nominatim returns a full display_name or structured address objects
      if (response && response.display_name) {
        return response.display_name; // E.g., "1600 Amphitheatre Pkwy, Mountain View, CA 94043"
      }

      return 'Address not found';
    } catch (error) {
      console.error('Geocoding error:', error);
      return 'Unable to fetch address';
    }
  }
}
